var _createForOfIteratorHelper = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _slicedToArray = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
/**
 * Abstract SVG Element
 */
var OrangeSVGAbstractElement = /*#__PURE__*/function () {
  "use strict";

  function OrangeSVGAbstractElement() {
    _classCallCheck(this, OrangeSVGAbstractElement);
  }
  _createClass(OrangeSVGAbstractElement, [{
    key: "_do_render",
    value:
    /**
     * Prepare render data
     *
     * @abstract
     * @private
     */
    function _do_render() {
      throw new Error('OrangeSVGAbstractElement._do_render should be overridden');
    }

    /**
     * Name of the tag
     *
     * @type string
     * @static
     * @abstract
     */
  }, {
    key: "args",
    get:
    /**
     * HTML attributes
     *
     * @type {Object}
     */
    function get() {
      return this._args || {};
    }

    /**
     * HTML attributes
     *
     * @type {Object}
     */,
    set: function set(value) {
      this._args = value;
    }

    /**
     * SVG Element converted to HTML string
     *
     * @return {string}
     */
  }, {
    key: "toString",
    value: function toString() {
      var render_data = this._do_render();
      var el_string = "<".concat(this.constructor.tag);
      for (var _i = 0, _Object$entries = Object.entries(render_data.hasOwnProperty('args') ? Object.assign(render_data.args, this.args) : this.args); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          name = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        el_string += " ".concat(name, "=\"").concat(value, "\"");
      }
      el_string += ">";
      if (render_data.hasOwnProperty('value')) {
        el_string += render_data.value;
      }
      el_string += "</".concat(this.constructor.tag, ">");
      return el_string;
    }

    /**
     * SVG Element converted to HTML string
     *
     * @param {string} namespace
     * @param {object} callbacks Javascript callbacks for the element (works only for DOM)
     * @param {?object} callback_data Data for callback
     * @return {SVGAElement | SVGCircleElement | SVGClipPathElement | SVGComponentTransferFunctionElement | SVGDefsElement | SVGDescElement | SVGEllipseElement | SVGFEBlendElement | SVGFEColorMatrixElement | SVGFEComponentTransferElement | SVGFECompositeElement | SVGFEConvolveMatrixElement | SVGFEDiffuseLightingElement | SVGFEDisplacementMapElement | SVGFEDistantLightElement | SVGFEFloodElement | SVGFEFuncAElement | SVGFEFuncBElement | SVGFEFuncGElement | SVGFEFuncRElement | SVGFEGaussianBlurElement | SVGFEImageElement | SVGFEMergeElement | SVGFEMergeNodeElement | SVGFEMorphologyElement | SVGFEOffsetElement | SVGFEPointLightElement | SVGFESpecularLightingElement | SVGFESpotLightElement | SVGFETileElement | SVGFETurbulenceElement | SVGFilterElement | SVGForeignObjectElement | SVGGElement | SVGImageElement | SVGGradientElement | SVGLineElement | SVGLinearGradientElement | SVGMarkerElement | SVGMaskElement | SVGPathElement | SVGMetadataElement | SVGPatternElement | SVGPolygonElement | SVGPolylineElement | SVGRadialGradientElement | SVGRectElement | SVGScriptElement | SVGStopElement | SVGStyleElement | SVGSwitchElement | SVGSymbolElement | SVGTSpanElement | SVGTextContentElement | SVGTextElement | SVGTextPathElement | SVGTextPositioningElement | SVGTitleElement | SVGUseElement | SVGViewElement | SVGElement}
     */
  }, {
    key: "createDOMElement",
    value: function createDOMElement(namespace) {
      var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback_data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var render_data = this._do_render();
      var el = document.createElementNS(namespace, this.constructor.tag);
      for (var _i2 = 0, _Object$entries2 = Object.entries(render_data.hasOwnProperty('args') ? Object.assign(render_data.args, this.args) : this.args); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          name = _Object$entries2$_i[0],
          value = _Object$entries2$_i[1];
        el.setAttribute(name, value.toString());
      }
      if (render_data.hasOwnProperty('value')) {
        el.innerHTML = render_data.value;
      }
      var _iterator = _createForOfIteratorHelper(Object.entries(callbacks).filter(function (v) {
          return !!v[1];
        })),
        _step;
      try {
        var _loop = function _loop() {
          var _step$value = _slicedToArray(_step.value, 2),
            event = _step$value[0],
            callback = _step$value[1];
          el.addEventListener(event, function (e) {
            callback(e, callback_data);
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return el;
    }
  }], [{
    key: "tag",
    get: function get() {
      throw new Error('OrangeSVGAbstractElement.tag should be overridden');
    }
  }]);
  return OrangeSVGAbstractElement;
}();
module.exports = OrangeSVGAbstractElement;